var authStoreGetters;
(function (authStoreGetters) {
    authStoreGetters["GET_ACCESS_TOKEN"] = "GET_ACCESS_TOKEN";
    authStoreGetters["GET_LOGIN_ERR_MSG"] = "GET_LOGIN_ERR_MSG";
})(authStoreGetters || (authStoreGetters = {}));
export default authStoreGetters;
